import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import Alert from "@mui/material/Alert";
import TableComponent from "../../components/TableComponent";

import PositionItem from "./PositionItem";

import { getPositions } from "../../api/positions";

const PositionsTable = () => {
  const { t } = useTranslation();
  const [positions, setPositions] = useState([]);

  useEffect(() => {
    (async () => {
      let newPositions = await getPositions();
      const positions = newPositions.map((position) => ({
        ...position,
        roleName: position.role.name,
      }));
      setPositions(positions);
    })();
  }, []);

  return (
    <>
      <h2>{t("positions")}</h2>
      {/* Not the dismissible Hint component on purpose: this is the explanation for the
          missing add/edit/delete controls, so it has to stay on screen. */}
      <Alert severity="info" sx={{ mb: 2 }}>
        {t("position.management_disabled")}
      </Alert>
      <TableComponent
        header={[
          { title: t("id"), sort: "id", style: { width: "5%" } },
          { title: t("position.name"), sort: "name" },
          { title: t("role.name"), sort: "roleName" },
          { title: t("position.status"), sort: "status", style: { width: "15%" } },
        ]}
        renderChildren={(position) => <PositionItem key={position.id} position={position} />}
        items={positions}
        search={["name", "id", "roleName"]}
        pagination
      />
    </>
  );
};

export default PositionsTable;
